<template>
  <div class="search-container search">
    <div class="search-header-container">
      <div class="search-header">
        <div class="search-title font-weight-bold">{{$t('searchPage.search')}}</div>
        <div>
          {{$t('searchPage.findedFromQuery')}}"<span class="font-weight-bold"
            >{{ this.filterModel.query }}</span><span>"</span>

         {{$t('searchPage.finded')}}
          <span class="font-weight-bold">
            {{ this.totalCount }} {{$t('searchPage.note')}}
          </span>
        </div>
      </div>
    </div>
    <div class="search-result-container mt-2 py-3">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <div v-else class="search-result">
        <div
          class="search-result-item"
          v-for="(item, index) in searchItems"
          :key="index"
        >
          <router-link :to="getSearchItemLink(item)">
            {{ item.title }}
          </router-link>
          <div class="search-result-item-type">
            {{ getPageType(item.type) }}
          </div>
          <div >
            {{ isEmptyDescription(item) }}
          </div>
        </div>
        <pagination
          class="mt-3"
          v-model="currentPage"
          :totalPageCount="totalPageCount"
          :selector="'.search'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { PageType } from '../../models/enums'
import serviceDataAccess from '../../services/service.data-access'
import Pagination from '../_shared/Pagination.vue'
export default {
  name: 'Search',
  components: { Pagination },
  data: () => ({
    query: null,
    loading: false,
    searchItems: [],
    currentPage: 1,
    totalCount: 0,
    totalPageCount: 0,
    filterModel: {
      pageSize: 10,
      pageIndex: 0,
      query: null
    }
  }),
  async beforeRouteUpdate(to, from, next) {
    this.filterModel.query = decodeURIComponent(to.query.q)
    if (this.$route.query.q) {
      await this.loadSearchResult()
      this.currentPage = 1
      next()
    }
  },
  async created() {
    this.filterModel.query = decodeURIComponent(this.$route.query.q)
    if (this.$route.query.q) {
      await this.loadSearchResult()
    }
  },
  methods: {
    async loadSearchResult() {
      this.loading = true
      const result = await serviceDataAccess.getSearchResult(this.filterModel)
      this.totalCount = result.totalCount
      this.totalPageCount = result.totalPageCount

      const data = result.data
      const links = await serviceDataAccess.getPagesLinks(data.map((e) => e.id))

      const searchData = data.map((e) => {
        const link = links.find((t) => t.pageId === e.id)
        // const displayContentLength = 150
        // var rawHtml = JSON.parse(e.content)
        // var div = document.createElement('div')
        // div.innerHTML = rawHtml
        // var content = div.textContent || div.innerHTML || ''

        // const textIndex = content.indexOf(this.filterModel.query)
        // var startIndex =
        //   textIndex <= displayContentLength
        //     ? 0
        //     : textIndex - displayContentLength
        // var endIndex =
        //   textIndex + displayContentLength > content.length
        //     ? content.length
        //     : textIndex + displayContentLength
        const Content = e.content//
        return {
          id: e.id,
          urlKey: link ? link.fullLink : e.urlKey,
          title: e.name,
          type: e.pageType,
          content: Content
        }
      })
      this.searchItems = searchData
      this.loading = false
    },
    getSearchItemLink(item) {
      var to = 'page/'
      switch (item.type) {
        case PageType.News:
          to += 'news-details/' + item.urlKey
          break
        case PageType.Vacancy:
          to += 'vacancy-details/' + item.urlKey
          break
        default:
          to += item.urlKey
          break
      }

      return to
    },
    getPageType(type) {
      var name
      switch (type) {
        case PageType.News:
          name = 'Новина'
          break
        case PageType.Vacancy:
          name = 'Вакансія'
          break
        default:
          name = 'Сторінка'
          break
      }
      return name
    },
    isEmptyDescription(item) {
      if (item.content !== '') {
        return '...' + item.content + '...'
      }
    }
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterModel.pageIndex = newVal - 1
        this.loadSearchResult()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables';

.search-container {
  font-size: 2rem;

  & > div {
    background-color: white;
    display: flex;
    justify-content: center;
  }

  .search-result,
  .search-header {
    max-width: 120rem;
    flex: 1 1 auto;
  }

  .search-header {
    padding: 4rem 0;
    .search-title {
      font-size: 3.8rem;
    }
  }
  .search-result {
    .search-result-item {
      padding-top: 24px;
      padding-block: 24px;
      border-bottom: 1px solid #cecece;

      a {
        text-decoration: none;
        color: black;
        font-weight: bold;
      }

      .search-result-item-content {
        font-size: 1.6rem;
      }

      .search-result-item-type {
        color: #cecece;
        font-size: 1.3rem;
      }
    }
  }
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .search-container {
    .search-result,
    .search-header {
      padding-left: 0.8rem;
      padding-right: 0.8rem;
    }
  }
}
</style>
